/**
 * Which parts of a text a help search matched, so the results can mark them. The rules are the
 * index's (HelpTokenizer, HelpCorpus): text splits into words of letters and digits, hyphenated words
 * stay whole, and a search word matches a word exactly or as its beginning — from two letters on.
 */
const WORD = /[\p{L}\p{N}]+(?:-[\p{L}\p{N}]+)*/gu;
const MIN_PREFIX_LENGTH = 2;

export interface HighlightPart {
  text: string;
  match: boolean;
}

export function highlightParts(text: string, query: string): HighlightPart[] {
  const terms = [...new Set([...query.toLowerCase().matchAll(WORD)].map((m) => m[0]))];
  const parts: HighlightPart[] = [];
  let last = 0;
  for (const word of text.matchAll(WORD)) {
    const length = matchedLength(word[0].toLowerCase(), terms);
    if (length === 0) continue;
    const start = word.index ?? 0;
    if (start > last) parts.push({ text: text.slice(last, start), match: false });
    parts.push({ text: text.slice(start, start + length), match: true });
    last = start + length;
  }
  if (last < text.length) parts.push({ text: text.slice(last), match: false });
  return parts;
}

/** How much of the word the search matched: all of it, the longest search word it begins with, or nothing. */
function matchedLength(word: string, terms: string[]): number {
  let longest = 0;
  for (const term of terms) {
    if (word === term) return word.length;
    if (term.length >= MIN_PREFIX_LENGTH && word.startsWith(term)) longest = Math.max(longest, term.length);
  }
  return longest;
}
